export abstract class IRecaptchaService {
    abstract GetToken(action:string):Promise<string>;
}

export class FakeRecaptchaService implements IRecaptchaService{
    GetToken(action:string): Promise<string> {
        return Promise.resolve(action);
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/Recaptcha/IRecaptchaService.ts